// ---------------------------- [ BREACH RATE CODE CONSTANTS ] ---------------------------- //
// Everyday Digital
export const WEEKLY_DIGITAL_RATE_CODE = 'WST_DIGI_DD'
export const WEEKLY_DIGITAL_RATE_CODE_INCREASE = 'WST_DIGI_$8'
export const WEEKLY_DIGITAL_RATE_CODE_INTRO_OFFER = 'WST_DIG_weekly4X8_1'

export const FIFTY_OFF_EVERYDAY_DIGITAL_12_WEEKS_RATE_CODE =
    'WST_DIGI$3.50x12_DD'
export const FIFTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE = 'WST_DIGI_$3.50X8W'
export const THIRTY_OFF_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE =
    'WST_DIGI$4.90x8_DD'
export const EVERYDAY_DIGITAL_52_WEEKS_RATE_CODE = 'WST_DIGI_12MTH25OFF'

// Everyday Digital + Weekend Papers
export const WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE = 'WST_PrSS+DIGI_DD'
export const WE_PAPER_EVERYDAY_DIGITAL_RATE_CODE_INCREASE = 'WST_PrSS+DIGI_$10'
export const FIFTY_OFF_WE_PAPER_EVERYDAY_DIGITAL_8_WEEKS_RATE_CODE =
    'WST_SS+DIG4.50X8W_DD'
export const SATURDAY_PAPER_EVERYDAY_DIGITAL_RATE_CODE = 'WST_PrSat+DIG'
export const SUNDAY_PAPER_EVERYDAY_DIGITAL_RATE_CODE = 'WST_PrSun+DIG'

// Everyday Digital + Fri-Mon Papers
export const FIFTY_OFF_FRI_MON_PAPER_AND_DIGITAL_12_WEEKS_RATE_CODE =
    'WST-M---FSS+DIG_6.5'

// Sport Digital + Print
export const SPORT_BREACH_DIGITAL_PRINT_RATE_CODE = 'WST-M--TFSS+D7.50_DD'

// ---------------------------- [ BREACH COUPON CODE CONSTANTS ] ---------------------------- //
export const BASE_50_DEAL_OFFERCODE = 'DIGDIS21'

// ---------------------------- [ BREACH PRICE CONSTANTS ] ---------------------------- //
export const EVERYDAY_DIGITAL = 8
export const EVERYDAY_DIGITAL_INCREASE = 8
export const WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL = 10
export const WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL_INCREASE = 10
export const FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL = 13
export const WEEKEND_DAY_PAPER_AND_EVERYDAY_DIGITAL = 9

export const FIFTY_OFF_EVERYDAY_DIGITAL = EVERYDAY_DIGITAL * 0.5
export const FIFTY_OFF_WE_PAPERS_AND_EVERYDAY_DIGITAL =
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL * 0.5
export const FIFTY_OFF_FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL =
    FRI_TO_MON_PAPERS_AND_EVERYDAY_DIGITAL * 0.5
export const THIRTY_OFF_EVERYDAY_DIGITAL = EVERYDAY_DIGITAL * 0.7
export const THIRTY_OFF_WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL =
    WEEKEND_PAPERS_AND_EVERYDAY_DIGITAL * 0.7
